import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

class InputField extends Component {
  render() {
    const {
      dataTracking,
      input,
      id,
      labelText,
      placeholder,
      min,
      max,
      type,
      beforeOnChange,
      afterOnChange,
      beforeOnBlur,
      afterOnBlur,
      onKeyDown,
      meta: {
        touched,
        error,
        invalid
      }
    } = this.props;

    const inputIsDatepicker = type === "date";
    const inputIsCheckbox = type === "checkbox";

    const containerClasses = {
      "form-group__field": true,
      "date-picker": inputIsDatepicker,
      "x-field x-field--checkbox": inputIsCheckbox,
      "form-group__msg--error": inputIsCheckbox && touched && invalid
    };

    const inputClasses = {
      "form-control": true,
      "x-input-checkbox x-checkbox x--vh": inputIsCheckbox
    };

    const labelClasses = {
      "x-field__label": true,
      "x-checkbox-label": inputIsCheckbox
    };

    const errorMessagingEnabled = error && touched;

    return (
      <div className="form-group">
        {inputIsCheckbox && errorMessagingEnabled && <strong className="form-group__msg form-group__msg--error">{error}</strong>}
        <div className={classNames(containerClasses)}>
          <input
            {...input}
            data-tracking={dataTracking}
            min={min}
            max={max}
            placeholder={placeholder}
            id={id}
            type={type}
            className={classNames(inputClasses)}
            onKeyDown={onKeyDown}
            onBlur={event => {
              beforeOnBlur(event);
              input.onBlur(inputIsCheckbox ? input.checked : event.target.value);
              afterOnBlur(event);
            }}
            onChange={event => {
              beforeOnChange(event);
              input.onChange(inputIsCheckbox ? !input.checked : event.target.value);
              afterOnChange(event);
            }} />
          {labelText &&
            <label className={classNames(labelClasses)} htmlFor={id}>
              <span>{labelText}</span>
            </label>
          }
        </div>
        {!inputIsCheckbox && errorMessagingEnabled && <span className="form-group__msg form-group__msg--error">{error}</span>}
      </div>
    );
  }
}

InputField.defaultProps = {
    beforeOnChange: () => {},
    afterOnChange: () => {},
    beforeOnBlur: () => {},
    afterOnBlur: () => {},
    onKeyDown: () => {}
};

InputField.propTypes = {
  input: PropTypes.object.isRequired,
  id: PropTypes.string,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  beforeOnChange: PropTypes.func,
  afterOnChange: PropTypes.func,
  beforeOnBlur: PropTypes.func,
  afterOnBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  dataTracking: PropTypes.object,
  showErrorLabel: PropTypes.bool
};

export default InputField;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Form/InputField.jsx
 **/